/**
 * Fichier d'initialisation complète des templates html dans chaque module de l'application
 * Utilise le $templateCache
 */
import angular from "angular";

const context = require.context("./", true, /^.*\.html$/);
const keys = context.keys();
let contextModuleKeyContext = [];

keys.forEach(k => {
	let moduleName = k.split("/")[1];

	moduleName = moduleName.replace("e-iti", "exploitation");

	if (contextModuleKeyContext[moduleName] == null) {
		contextModuleKeyContext[moduleName] = [];
	}

	contextModuleKeyContext[moduleName].push({
		key: k,
	});
});

for (const module in contextModuleKeyContext) {
	const keyList = contextModuleKeyContext[module];

	angular.module(module).run([
		"$templateCache",
		function ($templateCache) {
			keyList
				.forEach( ({key}) => {
					const newKey = key.replace("./", `app/`);
					$templateCache.put(newKey, context(key).default);
				});
		}
	]);
}